import { m, useScroll, useSpring, useReducedMotion } from "framer-motion";

/**
 * Barra fina de progresso de scroll no topo da página.
 * Respeita reduced-motion (sem spring animation).
 */
export function ScrollProgress() {
  const prefersReduced = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: prefersReduced ? 0 : 100,
    damping: prefersReduced ? 0 : 30,
    restDelta: 0.001,
  });

  return (
    <m.div
      className="sr-scroll-progress"
      style={{ scaleX: prefersReduced ? scrollYProgress : scaleX }}
      aria-hidden="true"
    />
  );
}
